import { render, staticRenderFns } from "./add-agencies.vue?vue&type=template&id=2d7366ff"
import script from "./add-agencies.vue?vue&type=script&lang=js"
export * from "./add-agencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports